import { useTranslation } from 'react-i18next'

export function LangSwitcher() {
  const { i18n } = useTranslation()
  const current = i18n.language.startsWith('zh') ? 'zh' : 'en'

  function toggle() {
    i18n.changeLanguage(current === 'en' ? 'zh' : 'en')
  }

  return (
    <button
      onClick={toggle}
      className="text-xs font-medium text-white/40 hover:text-white/80 transition-colors px-2 py-1 rounded hover:bg-white/5 border border-white/10 hover:border-white/20"
      title={current === 'en' ? '切换到中文' : 'Switch to English'}
    >
      {current === 'en' ? '中文' : 'EN'}
    </button>
  )
}
